import React from "react";
import { ContentSection } from "sprint-common-web";

import { RecordType } from "../../../../../../common/types/RecordType";
import { useFileRecordDetailsState } from "../../../hooks/useFileRecordDetailsState";
import { AudioFileRecordLanguagesSection } from "./audio/AudioFileRecordLanguagesSection";
import { SubtitleFileRecordLanguagesSection } from "./subtitle/SubtitleFileRecordLanguagesSection";
import { VideoFileRecordLanguagesSection } from "./video/VideoFileRecordLanguagesSection";

export const FileRecordLanguagesSection = (): JSX.Element => {
    const { fileRecordDetails, isLoading } = useFileRecordDetailsState();

    const height = 350;

    switch (fileRecordDetails.type) {
        case RecordType.Video:
            return <VideoFileRecordLanguagesSection height={height} />;

        case RecordType.Audio:
            return <AudioFileRecordLanguagesSection height={height} />;

        case RecordType.Subtitle:
            return <SubtitleFileRecordLanguagesSection height={height} />;

        default:
            return <ContentSection header="Languages" isLoading={isLoading} testId={"languages-content-section"} />;
    }
};
